import React from "react";
import SectionNumber from "./SectionNumber";

/**
 * Reusable image gallery section for subpages.
 * images: [{src, label}]
 */
export default function PageGallery({
  eyebrow = "Ilyenek vagyunk",
  title,
  subtitle,
  images,
  sectionN = "06",
  bg = "bg-white",
}) {
  return (
    <section
      data-testid="page-gallery"
      className={`relative ${bg} py-24 sm:py-32 overflow-hidden`}
    >
      <SectionNumber n={sectionN} />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <div className="grid md:grid-cols-12 gap-8 mb-12 items-end">
          <div className="md:col-span-7 reveal">
            <span className="eyebrow">{eyebrow}</span>
            <h2 className="font-serif text-pkcharcoal text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.05]">
              {title}
            </h2>
          </div>
          {subtitle && (
            <div className="md:col-span-5 reveal">
              <p className="text-pkcharcoal/70 text-base sm:text-lg leading-relaxed">
                {subtitle}
              </p>
            </div>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 auto-rows-[180px] sm:auto-rows-[220px] lg:auto-rows-[240px]">
          {images.map((img, i) => (
            <div
              key={i}
              data-testid={`page-gallery-item-${i}`}
              className={`gallery-item reveal ${
                i === 0 || i === 3 ? "row-span-2" : ""
              }`}
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              <img
                src={img.src}
                alt={img.label || ""}
                loading="lazy"
                className="w-full h-full object-cover"
              />
              {img.label && (
                <div className="gallery-overlay">
                  <div>
                    <div className="w-6 h-px bg-white/80 mb-2" />
                    <div className="text-white font-serif text-lg">
                      {img.label}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
